export default {
  namespaced: true,
  operational_security: {
    title: "Seguridad operativa",
    template: {
      title: "Plantilla | Plantillas formulario",
      name: "Nombre",
      question: "Pregunta | Preguntas",
      add_new_field: "Agregar un nuevo campo",
      type_response: "Tipo de respuesta",
      field_name: "Nombre del campo",
      field_types: "Tipos de campo",
      field_type_config: "Configuración del tipo de campo",
      options: "Opciones",
      option_name: "Nombre de la opción",
      add_option: "Agregar una opción",
      added_options: "Opciones agregadas",
      add_section: "Agregar sección",
      new_section: "Nueva sección",
      section_name: "Nombre de la sección",
      no_section: "Sin sección",
      add_field_here: "Agregar pregunta",
      drop_or_add_here: "Arrastra o agrega aquí",
      confirm_delete_section:
        "¿Eliminar la sección? Sus preguntas pasarán a 'Sin sección'.",
      confirm_delete_field: "¿Eliminar esta pregunta?",
      is_group: "Múltiple"
    },
    evaluation: {
      title: "Respuestas de formulario",
      command_executed: "Comando ejecutado",
      command_queued: "Comando en cola",
      command_running: "Ejecutando comando",
      command_succeeded: "Comando ejecutado correctamente",
      command_failed: "Error al ejecutar el comando",
      command_retry: "Reintentar",
      command_check_result: "Consultar resultado",
      command_tracking_error: "No fue posible iniciar o confirmar la ejecución del comando.",
      command_tracking_timeout: "La ejecución continúa sin un resultado confirmado. Consulte nuevamente el mismo intento.",
      command_retry_title: "Reintentar comando",
      command_retry_warning: "El intento anterior pudo ejecutarse parcialmente. ¿Desea volver a ejecutar el comando?",
      select_form: "Selecciona el formulario de seguridad operativa",
      new_evaluation: "Contestar formulario",
      edit_evaluation: "Editar respuestas del formulario",
      form_start_at: "Fecha de inicio",
      form_end_at: "Fecha de finalización",
      sent_to: "Enviado a",
      shortcuts: "Accesos directos",
      status: {
        in_progress: "En progreso",
        pending: "Pendiente",
        review: "En revisión",
        completed: "Completado",
        rejected: "Rechazado",
        reopened: "Reasignado",
        in_review: "En revisión",
        approved: "Aprobado",
        canceled: "Cancelado",
        commented: "Comentado",
        updated: "Actualizado"
      },
      email_preview: "Vista previa del email",
      validation_comments: "Comentarios de la validación",
      reopened_comments: "Comentarios del formulario reabierto",
      create_sitrep: "Crear SITREP",
      create_newsletter: "Crear boletín informativo",
      create_news_flash: "Crear flash informativo",
      create_informative_email: "Crear correo informativo",
      send_form: "Enviar formulario",
      error_send_form: "Error al enviar formulario",
      success_send_form: "Formulario enviado con éxito",
      answers_successfully: "Respuestas guardadas con éxito",
      answers_error: "Error al guardar las respuestas",
      reload: "Recargar",
      review_successfully: "Enviado a revisión con éxito",
      review_error: "Error al enviar el formulario a revisión",
      status_successfully: "Estatus actualizado con éxito",
      status_error: "Error al actualizar el estatus",
      reopen_successfully: "Formulario reabierto con éxito",
      reopen_error: "Error al reabrir el formulario",
      related_forms: "Formularios relacionados",
      mailable: "Enviable",
      standard: "Estándar",
      loading_tracking: "Cargando seguimiento del formulario...",
      create: "Crear",
      does_not_apply: "No aplica",
    },
    prefill: {
      title: "Pre-registros",
      search: "Búsqueda por referencia, SOEID, sucursal",
      create: "Crear pre-registro",
      table_tooltip: "Arrastra y suelta un pre-registro para completar el formulario",
      reference: "Referencia",
      facility: "Sucursal",
      event_type: "Tipo de evento",
      date: "Fecha",
      questions: "Preguntas",
      another_facility: "Otro inmueble",
      close: "Cerrar pre-registro",
      edit: "Editar pre-registro",
    },
    operational_processes: {
      title: "Control de personal externo",
      folio: "Folio de bitácora",
      unit: "Inmueble",
      unit_placeholder: "Seleccione una instalación",
      category: "Categoría",
      state: "Estado",
      municipality: "Municipio",
      subregion: "Subregión",
      check_in_datetime: "Fecha/hora ingreso",
      check_out_datetime: "Fecha/hora salida",
      company: "Proveedor",
      company_placeholder: "Seleccione proveedor",
      employee: "Técnicos asignados",
      employee_placeholder: "Seleccione técnico",
      report_number: "Ticket",
      activities: "Actividades o tipo de proyecto",
      system: "Sistemas",
      is_test_mode_enabled: "Activar modo de pruebas",
      is_test_mode_enabled_placeholder: "Seleccione",
      type_of_maintenance: "Tipo de mantenimiento",
      type_of_maintenance_placeholder: "Seleccione tipo de mantenimiento",
      panel: "Panel",
      panel_placeholder: "Seleccione el panel",
      tenant_origin: "Tenant de origen",
      tenant: "Tenant mantenimiento",
      tenant_placeholder: "Seleccione tenant mantenimiento",
      add_partial_checkout: "Agregar salida parcial",
      partial_checkout_check_in_datetime: "Fecha/hora inicio",
      partial_checkout_check_out_datetime: "Fecha/hora reingreso",
      partial_checkout_description: "Descripción",
      partial_checkout_is_systems_enabled: "Reactivar sistemas",
      delete: "Eliminar",
      generate_timestamp: "Da click para generar marca de tiempo",
      status: "Estatus",
      maintenance_devices: "Dispositivos en mantenimiento",
      sirh: "SIRH",
      rems: "REMS",
      id_seproban: "ID SEPROBAN",
      finish_maintenance: "Terminar mantenimiento",
      maintenance: "Mantenimiento",
      project_implementation: "Implementación de proyectos",
      image: "Imagen",
      name: "Nombre",
      step_create: "Crear bitácora",
      step_information: "Información del proceso",
      step_panel_configuration: "Configuración del panel",
      type: "Tipo",
      user_start: "CCB entrada",
      user_finish: "CCB salida",
      siren_enabled: "Sirena habilitada y prueba de sirena a la salida",
      siren_disabled: "Sirena deshabilitada en Remote a la entrada",
      infrared_height: "Altura infrarrojos patio público",
      infrared_validated: "Infrarrojo validado",
      service_time: "Tiempo de atención",
      sector: "Región",
      panel_password: "Clave panel",
      panel_delete_password: "Se borra clave en panel",
      panel_users: "Usuario técnico del panel",
      panel_users_placeholder: "Seleccione un usuario",
      panels_empty: "No se encontraron paneles en la instalación",
      panel_users_empty: "No se encontraron usuarios técnicos del panel",
      panel_user_code: "Código de usuario",
      panel_user_code_placeholder: "Da click para generar código",
      technicians: "Técnicos",
      devices: "Dispositivos",
    },
    create_registration: "Crear registro",
    select_form_place_holder: "Busque y seleccione un formulario",
    select_facility_to_enable_command: "Seleccione una instalación para habilitar el comando.",
    form_id_to_enable_command: "Es necesario crear el formulario para habilitar el comando.",
    crisis_form: {
      add: "Agregar Formulario de Crisis",
      title: "Formulario de crisis",
      name: "Nombre",
      reference_number: "Número de referencia",
      responsable: "Responsable(s)",
      unitsAdded: "Instalaciones agregadas",
      addUnits: "Agregar instalaciones",
      emptyUnits: "No hay instalaciones agregadas",
      risk: "Riesgo",
      total_employees: "Total empleados",
      total_facilities: "Total Sucursales",
      buildings: "Edificios y anexos",
      cpae: "Total CPAE´s",
      cpd: "Total CPD´s",
      facilities_atm: "Total ATM´s sucursales",
      third_partys_atm: "Total ATM´s terceros",
      payroll_atm: "Total ATM´s nominas",
      mobile_unit: "Unidad móvil",
      mobile_unit_atm: "Total ATM´s unidad móvil",
      master_data: "Base maestra",
      allocations_by_region: "Afectaciones por estado",
      allocations_by_municipality: "Afectaciones por municipio",
      preventive_closures: "Cierres preventivos",
      offline_facilities: "Sucursales offline",
      facilities_with_water_filtration_systems: "Sucursales con filtración de agua / caida de plafones",
      broken_glass: "Rotura de cristales",
      damaged_cameras: "Cámaras dañadas",
      buildings_offline: "Edificios offline",
      buildings_with_water_leaks: "Edificios con filtración de agua / caida de plafones",
      CPAES_offline: "CPAEs offline",
      CPAES_closures: "CPAEs cierre",
      facilities_with_offline_ATMs: "ATM´s offline sucursales",
      third_party_offline_ATMs: "ATM´s offline terceros / nómina",
      officials_contacted: "Funcionarios contactados",
      support_civil_servants: "Apoyo a funcionarios",
      blocked_roads: "Caminos/vialidades bloqueados",
      total_branches: "Total de sucursales",
      total_mobile_unit: "Total unidad móvil",
      total_atm: "Total ATM´s",
      total_emergency_kits_delivered: "Total kits de emergencia entregados",
      total_generators_delivered: "Total generadores entregados",
      csis: "CSIS",
      csis_days_in_field: "Días de CSIS en campo",
      csis_total_volunteers: "Total voluntarios CSIS",
      loss: "Pérdidas",
      operational: "Operativo",
      total_affecting_cash: "Total afectado efectivo",
      cash_impact: "Impacto en efectivo",
      total: "Total",
      level: "Nivel",
      description: "Descripción",
      to_list_id: "Para",
      cc_list_id: "Copia",
      bcc_list_id: "Copia oculta",
      allocations_by_facility: "Afectaciones por sucursales",
      inpact_on_operations: "Afectación a la operación",
      complete_closure: "Cierre total",
      early_closing: "Cierre anticipado",
      late_opening: "Apertura tardía",
      out_of_service: "Fuera de servicio",
      offline: "Offline",
      reset: "Restablece",
      CCTV: "CCTV",
      water_leakage: "Filtración de agua y caída de plafones",
      public_courtyard: "Patio público",
      etv_transfer_box: "ETV Transfer Box",
      internal_areas: "Áreas internas",
      box_train: "Tren de cajas",
      atm_area: "Recinto de cajeros",
      parking: "Estacionamiento",
      broken_glass: "Cristales rotos",
      side_walls_or_facade: "Laterales o fachada",
      main_entrance: "Acceso principal",
      atm_in_operation: "ATM´s en operación",
      atm_damages: "Daños en ATMs",
      broken_screen: "Pantalla rota",
      broken_lock: "Chapa dañada",
      open: "Abierto",
      risk_facilities: "Sucursales de riesgo",
      has_operational_backup_power: "Cuenta con planta de emergencia",
      backup_power_capacity: "Capacidad de la planta de emergencia",
      diesel_level: "Nivel de diésel",
      UPS: "UPS",
      facility_with_anticyclonic_curtain: "Sucursal con cortina anticiclónica",
      facility_with_glass_facade: "Sucursal con fachada de cristal",
      facility_near_rivers: "Sucursal cercana a ríos",
      metal_roof: "Techo de lamina",
      encased_in_solid_material: "Confinada con material sólido",
      at_the_mall: "En centro comercial",
      vacant_lots: "Lotes baldíos",
      employee_information_by_facility: "Información de empleados por sucursal",
      employee_name: "Nombre del empleado",
      geid: "GEID",
      employee_position: "Puesto de empleado",
      contact_number: "Teléfono de contacto",
      emergency_number: "Teléfono de emergencias",
      street_address_house_number: "Domicilio calle y número",
      neighborhood: "Colonia",
      municipality: "Municipio",
      assigned_sirh: "SIRH asignado",
      facility_name: "Nombre de la sucursal",
      status_confirmation_call_tree: "Confirmación de estatus por respuesta de call tree",
      i_feel_fine: "Me encuentro bien",
      by_mistake: "Por error",
      need_help: "Necesito ayuda",
      unreachable: "No localizable",
      evacuated: "Evacuado",
      contacted_by: "Contactado por",
      ccb: "CCB",
      business: "Negocio",
      csis: "CSIS",
      damages_and_needs: "Daños y necesidades",
      flooded_home: "Domicilio inundado",
      shortage_of_food_supplies: "Falta de víveres",
      emergency_plant: "Planta de emergencia",
      damaged_vehicle: "Vehículo dañado",
      lack_of_public_transportation: "Falta de transporte público",
      filters_by_region_city: "Filtros por estado, municipio.",
      only_rows_with_data: "Solo filas con información"
    },
    confirmGoBack: "¿Estás seguro de que deseas salir?",
    confirmGoBackSubtitle: "Si tienes cambios sin guardar se perderán.",
    show_horizontal_form: "Mostrar formulario",
    close_horizontal_form: "Cerrar formulario",
    activities: {
      title: "Actividades",
      description: "Descripción",
    },
    description: "Descripción",
    security_manager_comments: "Comentarios del director de seguridad",
    save_comments: "Guardar comentarios",
    save_comments_success: "Comentario guardado con éxito",
    sec_manager_comments: "Comentarios del director de seguridad",
    sirh_facility_name: 'SIRH y Nombre Sucursal',
    security_monitoring: 'Seguimiento seguridad física',
    last24h: 'Últimas 24 horas',
    last48h: 'Últimas 48 horas',
    lastWeek: 'Última semana',
    lastMonth: 'Último mes',
    significant_event_pending_comments: 'Evento relevante pendiente de comentarios',
    significant_event_save_success: 'Evento relevante guardado con éxito',
  },
};
